import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class TratamentoCustoFixoService {
    constructor(
        private apiService: ApiService
    ) {}

    post(form) : Observable<any> {
        return this.apiService.post('/custo-fixo', form)
    }
    
    getAll( idTratamento ): Observable<any> {
        let url : string = `/custo-fixo`
        return this.apiService.get(url, idTratamento)
    }

    get(id: string): Observable<any> {
        let url : string = `/custo-fixo/${id}`
        return this.apiService.get(url)
    }

    put(id: string, form) : Observable<any> {
        form._method = 'PUT'
        return this.apiService.post('/custo-fixo/'+id, form)
    }

    delete(id) {
        return this.apiService.delete('/custo-fixo/'+id)
    }

}